/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListRiskCategoriesSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListRiskCategoriesSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListRiskCategoriesSecurity = {
  option1?: ListRiskCategoriesSecurityOption1 | undefined;
  option2?: ListRiskCategoriesSecurityOption2 | undefined;
};

export type ListRiskCategoriesRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListRiskCategoriesSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListRiskCategoriesSecurityOption1$outboundSchema: z.ZodMiniType<
  ListRiskCategoriesSecurityOption1$Outbound,
  ListRiskCategoriesSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listRiskCategoriesSecurityOption1ToJSON(
  listRiskCategoriesSecurityOption1: ListRiskCategoriesSecurityOption1,
): string {
  return JSON.stringify(
    ListRiskCategoriesSecurityOption1$outboundSchema.parse(
      listRiskCategoriesSecurityOption1,
    ),
  );
}

/** @internal */
export type ListRiskCategoriesSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListRiskCategoriesSecurityOption2$outboundSchema: z.ZodMiniType<
  ListRiskCategoriesSecurityOption2$Outbound,
  ListRiskCategoriesSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listRiskCategoriesSecurityOption2ToJSON(
  listRiskCategoriesSecurityOption2: ListRiskCategoriesSecurityOption2,
): string {
  return JSON.stringify(
    ListRiskCategoriesSecurityOption2$outboundSchema.parse(
      listRiskCategoriesSecurityOption2,
    ),
  );
}

/** @internal */
export type ListRiskCategoriesSecurity$Outbound = {
  Option1?: ListRiskCategoriesSecurityOption1$Outbound | undefined;
  Option2?: ListRiskCategoriesSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListRiskCategoriesSecurity$outboundSchema: z.ZodMiniType<
  ListRiskCategoriesSecurity$Outbound,
  ListRiskCategoriesSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListRiskCategoriesSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListRiskCategoriesSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listRiskCategoriesSecurityToJSON(
  listRiskCategoriesSecurity: ListRiskCategoriesSecurity,
): string {
  return JSON.stringify(
    ListRiskCategoriesSecurity$outboundSchema.parse(listRiskCategoriesSecurity),
  );
}

/** @internal */
export type ListRiskCategoriesRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListRiskCategoriesRequest$outboundSchema: z.ZodMiniType<
  ListRiskCategoriesRequest$Outbound,
  ListRiskCategoriesRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listRiskCategoriesRequestToJSON(
  listRiskCategoriesRequest: ListRiskCategoriesRequest,
): string {
  return JSON.stringify(
    ListRiskCategoriesRequest$outboundSchema.parse(listRiskCategoriesRequest),
  );
}
